// 成本顯示工具
// 後端 functions/_lib/usage.ts 已用真實價格（Sonnet 4.6 input $3 / output $15 per 1M tokens）
// 計算好 USD 並乘上即時匯率（TWD_PER_USD env，預設 32），這裡只負責格式化

import type {
  ClaudeCostBreakdown,
  JobResultCost,
  WhisperCostBreakdown,
} from "@/types";

export function formatTwd(twd: number): string {
  if (twd < 0.01) return `< NT$0.01`;
  if (twd < 1) return `NT$${twd.toFixed(3)}`;
  if (twd < 100) return `NT$${twd.toFixed(2)}`;
  return `NT$${twd.toFixed(0)}`;
}

export function formatUsd(usd: number): string {
  if (usd < 0.0001) return `< $0.0001`;
  if (usd < 0.01) return `$${usd.toFixed(4)}`;
  return `$${usd.toFixed(3)}`;
}

export function formatTokens(n: number): string {
  return n.toLocaleString("en-US");
}

// 提取「主要 model 名稱」（claude-sonnet-4-6-20260101 → sonnet 4.6）
export function shortModelName(model: string | null | undefined): string {
  if (!model) return "Claude";
  if (/opus-4-7/.test(model)) return "Claude Opus 4.7";
  if (/sonnet-4-6/.test(model)) return "Claude Sonnet 4.6";
  if (/haiku-4-5/.test(model)) return "Claude Haiku 4.5";
  return model;
}

export function summarizeClaudeCost(c: ClaudeCostBreakdown): string {
  const parts = [
    `${formatTokens(c.input_tokens)} 輸入`,
    `${formatTokens(c.output_tokens)} 輸出`,
  ];
  if (c.cache_read_tokens > 0) {
    parts.push(`${formatTokens(c.cache_read_tokens)} 快取讀`);
  }
  if (c.cache_write_tokens > 0) {
    parts.push(`${formatTokens(c.cache_write_tokens)} 快取寫`);
  }
  return `${parts.join(" / ")} tokens · 約 ${formatTwd(c.twd)}`;
}

export function summarizeWhisperCost(w: WhisperCostBreakdown): string {
  return `${w.seconds.toLocaleString()} 秒音訊 · 約 ${formatTwd(w.twd)}`;
}

// 從 result_data 解析成本（process job 回傳的 result_data）
export function parseCostFromResultData(raw: string | null): JobResultCost | null {
  if (!raw) return null;
  try {
    const data = JSON.parse(raw) as { cost?: JobResultCost };
    return data.cost ?? null;
  } catch {
    return null;
  }
}
